import { useContext } from "react";

import { GetProjectDetailsResponse as GetPublicProjectDetailsResponse } from "../../../../../service/publicquery";
import { GetProjectDetailsResponse } from "../../../../../service/query";
import { ProjectContext } from "../../../../shared/projects/project/ProjectContext";

interface UseInventoryReturnData {
  projectDetails: GetProjectDetailsResponse | undefined;
  publicProjectDetails: GetPublicProjectDetailsResponse | undefined;
}

export const useInventory = (): UseInventoryReturnData => {
  const { projectDetails, publicProjectDetails } = useContext(ProjectContext);

  return {
    projectDetails,
    publicProjectDetails,
  };
};
